import {
    DataSource, DataSourceMode, DataSourceExecutionEvent} from "@mcleod/components";
import { ErrorHandlerFunction, ModelRow, Navigation, StringUtil, UrlUtil } from "@mcleod/core";

import { OrderMapViewUnauthenticated } from "./OrderMapViewUnauthenticated";
import { AutogenLayoutTrackWithoutLoginDetailed } from "./autogen/AutogenLayoutTrackWithoutLoginDetailed";

export class TrackWithoutLoginDetailed extends AutogenLayoutTrackWithoutLoginDetailed {


    override onLoad() {
        const urlProp = this.getUrlParams();
        if (urlProp?.id && !StringUtil.isEmptyString(urlProp.id)) {
            this.mainDataSource.search({ token_id: urlProp.id }, this._errorHandler).then(response => this.checkResponse(response))
        } else {
            Navigation.navigateTo("");
        }

        const orderMapViewLayout = this.layoutOrderDetailsUnauthenticated.tabMapView.findComponentById("layoutOrderMapView") as OrderMapViewUnauthenticated;
        orderMapViewLayout.map1.immediatelyActivateMap = true;

        this.addLayoutLoadListener(event => {
            this.layoutOrderDetailsUnauthenticated.tabsetOrderDetails.addAfterTabSelectionListener(event => {
                if (event.newSelection === this.layoutOrderDetailsUnauthenticated.tabMapView) {
                    orderMapViewLayout.map1.fitPins();
                }
            });
        });

    }

    async mainDataSourceAfterExecution(event: DataSourceExecutionEvent) {
        const urlProp = this.getUrlParams();

        if (urlProp?.id && !StringUtil.isEmptyString(urlProp.id)) {

            this.layoutOrderDetailsUnauthenticated.mainDataSource.search({ token_id: urlProp.id }, this._errorHandler).then(response => 
                {
                    const orderMapViewLayout = this.layoutOrderDetailsUnauthenticated.tabMapView.findComponentById("layoutOrderMapView") as OrderMapViewUnauthenticated;
                    orderMapViewLayout.setUpMap(response);
                    const row = response?.modelRows[0] as ModelRow;
                    const trackingPositions = row.get("tracking_positions");
                    const modelRowPositions = [];
                    trackingPositions.forEach(position => {
                        if (position.event) {
                            modelRowPositions.push(new ModelRow(this.layoutOrderDetailsUnauthenticated.mainDataSource.url, false, position));
                        }
                    });
                    if (modelRowPositions.length > 0) {
                        const sourceTrackingPositions = new DataSource();
                        sourceTrackingPositions.setRowsAndMode(DataSourceMode.NONE, modelRowPositions);
                        this.layoutOrderDetailsUnauthenticated.tableTracking.dataSource = sourceTrackingPositions;
                        modelRowPositions.forEach(modelRow => {
                            this.layoutOrderDetailsUnauthenticated.tableTracking.displayData(modelRow, modelRowPositions, 0);
                        });
                    } else {
                        this.layoutOrderDetailsUnauthenticated.tableTracking.clearRows();
                    }
                });
                   
        }
    }

    private checkResponse(response: any) {
        if (!response?.modelRows?.length) {
            this.panelMain.visible = false;
        }
        else {
            this.panelMain.visible = true;
        }
    }

    private getUrlParams() {
        return UrlUtil.getPropsFromUrl(document.location.search);
    }

    _errorHandler: ErrorHandlerFunction = (error) => {
        Navigation.navigateTo("");
    }
}